import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { getProperty, ImageItem } from '@core/_utils/tools.utils';
import { AddFileService } from '@service/addfile.service';
import { ApiV6Service } from '@service/apiv6.service';
import { Communication } from '@service/communication';
import { DocumentService } from '@service/document.service';
import { IndexedDbService } from '@service/indexeddb.service';
import {
  NgxExtendedPdfViewerComponent,
    NgxExtendedPdfViewerModule,
    NgxExtendedPdfViewerService,
    pdfDefaultOptions,
} from 'ngx-extended-pdf-viewer';
import { MenuItem } from 'primeng/api';
import {lastValueFrom} from 'rxjs';
import {DialogModule} from "primeng/dialog";
import {Button} from "primeng/button";
import {ProgressBarModule} from "primeng/progressbar";
import {ImageGalleryComponent} from "@documalis/images";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FileUploadModule } from 'primeng/fileupload';

@Component({
  selector: 'composition-pdf',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
      DialogModule,
      Button,
      ProgressBarModule,
      NgxExtendedPdfViewerModule,
      ImageGalleryComponent,   
      TranslateModule,
      FileUploadModule
  ],
  providers: [NgxExtendedPdfViewerService, NgxExtendedPdfViewerComponent],
  templateUrl: './composition-pdf.component.html',
  styleUrl: './composition-pdf.component.scss'
})
export class CompositionPdfComponent implements OnInit, OnChanges {

  public variableList: any[] = [];

  public pathPdf: any;
  protected page: any;
  protected currentPage: any;

  public imageDataURL: string | undefined = undefined;

  public background: string | undefined;

  public scale!: number;

  public width!: number;

  public height!: number;
  public widthDisplay!: number;

  public heightDisplay!: number;

  public selectedTabIndex = 0;
  public displayThumbnails = false;
  public nbPages: number = 0;
  public prgBarr: number = 0;
  public prcProgress: number = 0;

  public parentImageItems: ImageItem[] = [];
  public menuImage: MenuItem[] = [];
  public docInfos: any[];
  public docIndex: any;

  public selectedFile: File;
  public selectedFiles: File[] = [];
  @Input() docId!: string;
  @Input() public currentSelectedBsk;
  @Input() visible!: boolean;
  @Output()
  public onClose: EventEmitter<any> = new EventEmitter();

  @ViewChild('pdfviewerpdf') public pdf_viewer_pdf: NgxExtendedPdfViewerComponent;
  private exportError: boolean = false;
  constructor(
    private indexedDbService: IndexedDbService,
    private api: ApiV6Service,
    private comm: Communication,
    protected messageService: MessagesService,
    private addFileService: AddFileService,
    private pdfViewerService: NgxExtendedPdfViewerService,
    private documentService: DocumentService,
    private _translate: TranslateService,
 ) {
    pdfDefaultOptions.textLayerMode = 1;
    pdfDefaultOptions.enableSignatureEditor = true;
    this.menuImage = [];
    this.docInfos = [];
    this.docIndex = [];
    this.parentImageItems = [];
    this.initialize();
  }

  public ngOnInit() {}

  public ngOnChanges() {
    if (this.visible) {
      this.getInfosDoc().then(() => {
      });
    }
  }

  private async getInfosDoc() {
    this.pathPdf = '';
    this.parentImageItems = [];
    this.prgBarr = 0;
    this.displayThumbnails = false;
    try {
      const response = await lastValueFrom(
        this.documentService.readInfosDocIndex(false, this.indexedDbService.variableStorage)
      );
      this.docInfos = response.getInfoDoc.Document;
      this.docIndex = response.getIndexDoc.VariableList.Variable;
      this.pathPdf = this.api.getPdf(this.docId);
    } catch (error) {
      this.messageService.addErrorMsg(this._translate.instant('Load_Data_KO'));
    }
  }

  public async exportAsImg(): Promise<void> {
    this.displayThumbnails = false;
    

    await this.doExportAsImage().then(() => {
      this.displayThumbnails = true;
      this.prgBarr = 0;
      this.prcProgress = 0;
    });
    if (this.exportError === true) {
      this.messageService.addErrorMsg(this._translate.instant('CompoExtractError'));
      // await this.resetViewer();
      this.close('composeError');
    }
  }

  public async doExportAsImage(): Promise<void> {
    try {
      this.height = 320;
      this.exportError = false;
      const scale = { width: this.width, height: this.height, scale: this.scale };
      // Assuming that `this.pdfViewerService.getTotalPages()` returns the total number of pages in the PDF
      const totalPages: number = this.pdfViewerService.numberOfPages();
  
      this.nbPages = 1;
      this.prgBarr = 0;
      this.prcProgress = 0;
      let wPrgBarr = Math.round((100 / totalPages) * 100) / 100;
      let dataURL;
      for (this.nbPages = 1; this.nbPages <= totalPages; this.nbPages++) {
        try {
          dataURL = await Promise.race([
              this.pdfViewerService.getPageAsImage(this.nbPages, scale, this.background),
              new Promise((_, reject) =>
                  setTimeout(() => reject(new Error(`Timeout reached for page ${this.nbPages}`)), 2000)
              )
          ]);            
        } catch (error) {
          this.exportError = true;
          this.parentImageItems.push({
            url: '/assets/layout/images/documalis_logo.png',
            page: this.nbPages.toString(),
            action: '',
            rotate: 0,
            numPageOrig: this.nbPages.toString()
          });
        }
        this.parentImageItems.push(({
          url: dataURL,
          page: this.nbPages.toString(),
          action: '',
          rotate: 0,
          numPageOrig: this.nbPages.toString()
        }));
        this.prgBarr = this.prgBarr + wPrgBarr;
        this.prcProgress = Math.trunc(this.prgBarr);
        if (this.prgBarr >= 100) {
          this.prgBarr = 100;
          this.prcProgress = 100;
        }
      }
      if (this.nbPages >= totalPages) {
        this.prgBarr = 100;
        this.prcProgress = 100;
      }
      for (let i = 0; i < this.parentImageItems.length; i++) {
        // Détection des pages originales, vérification si changement de page
        if (this.parentImageItems[i].page !== this.parentImageItems[i].numPageOrig) {
          this.parentImageItems[i].numPageOrig = this.parentImageItems[i].page;
        }
        this.parentImageItems[i].page = (i + 1).toString();
      }
    } catch (error) {
      console.log('doExportAsImage error', error);
      this.messageService.addErrorMsg(this._translate.instant('CompoExtractError'));
      this.close('composeError');
    }
  }

  async onPdfLoadComplete(event: any) {
    try {
      await this.exportAsImg();
      if (this.exportError === true) {
        event.source.cleanup();        
      }
    } catch (error) {
      console.log('doExportAsImage error', error);
      this.messageService.addErrorMsg(this._translate.instant('CompoExtractError'));
      this.close('composeError');
    }
  }

  onEvent(event: any, data: any) {
    this.messageService.addErrorMsg(this._translate.instant('CompoExtractError'));
    console.log('onEvent', event, data);
  }

  onSelect($event) {
    const file = $event.currentFiles[0];
    this.displayThumbnails = false;
    this.pathPdf = new Blob([file]);
    if ($event.currentFiles[0] !== undefined) {
      this.selectedFiles.push($event.currentFiles[0]);
    }
  }

  async resetViewer() {
  try {
    this.displayThumbnails = false;
    this.pathPdf = '';
    this.pdf_viewer_pdf.src = '';

    } catch (error) {
        console.log('Error resetting PDF viewer:', error.message);
    }
  }

  public async onClickButtonValid(event) {
    let wAction = this.verifyActions();
    switch (wAction) {
      case 'noAction':
        this.messageService.addWarnNoStick(this._translate.instant('Compo_NoAction'));
        return;
      case 'noPage':
        this.messageService.addWarnNoStick(this._translate.instant('Compo_NoPage'));
        return;              
    }
    await this.execValid();
  } 

  private async execValid() {
    let wPageActions: any[] = [];
    this.parentImageItems.forEach(element  => {
      wPageActions.push({page: element.page, action: element.action, rotate: element.rotate, numPageOrig: element.numPageOrig});      
    });

    const formData = new FormData();
    if (this.docInfos.length > 0) {
      this.prepareInfosDoc(formData);
    }
    formData.append('pageActions', JSON.stringify(wPageActions));

    if (this.selectedFiles && this.selectedFiles.length > 0) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append('files[]', this.selectedFiles[i], this.selectedFiles[i].name);
      }
    }
    try {
      await lastValueFrom(this.comm.postUrl('/workpdf', formData)).then(
        r => {
          this.messageService.addSuccess(this._translate.instant('Send_OK'));
          this.close('composeSuccess');
        }
      );
    } catch (error) {
        console.log('Error', error);
        this.messageService.addErrorMsg(this._translate.instant(error.error.CodeMessage));
        this.close('composeError');
    }
  }

  private prepareInfosDoc(formData) {
    let Variable: any;
    let VariableList = new Array();
    let wjson = '';
    let wFileName = '';

    wFileName = getProperty(this.docInfos, 'Name');

    wjson = JSON.stringify(this.addFileService.getDocumentList());
    formData.append('DocumentList', wjson);
    wjson = JSON.stringify(this.addFileService.getDocument(wFileName, 0, getProperty(this.docInfos, 'BaseRoot'), getProperty(this.docInfos, 'StoragePath')));
    formData.append('Document', wjson);

    if (this.docIndex.Variable && this.docIndex.Variable.length > 0) {
      this.docIndex.Variable.map((item) => {
            Variable = new Object();
            Variable.Name = item.Name;
            Variable.Type = item.type;
            Variable.Value = item.value
            VariableList.push({ Variable: Variable });
        }
      );
    }
    let wVariable = {
      VariableList: VariableList,
    };

    wjson = JSON.stringify(wVariable);
    formData.append('Variable', wjson);

    wjson = JSON.stringify(this.addFileService.getRequestSend('', this.currentSelectedBsk.bskType, this.currentSelectedBsk.bskName));
    formData.append('BasketEngine', wjson);

    formData.append('priority', '5');

    formData.append('docId', this.docId);
  }

  private verifyActions(): string {
    let hasAction = false;
    let allDeleted = true;
    let hasMove = false;

    for (const element of this.parentImageItems) {
      if (element.page !== element.numPageOrig) {
        hasMove = true;
      }
      if (element.action !== '' || element.rotate !== 0) {
        hasAction = true;
      }
      if (element.action !== 'delete') {
        allDeleted = false;
      }
    }
    if (allDeleted === true) {
      return 'noPage';
    }
    if (hasAction === false && hasMove === false) {
      return 'noAction';
    }
    return '';
  }

  public onimageItemsChange($event) {
    console.log('onimageItemsChange', $event);
  }

  public close(event) {
    this.visible = false;
    this.onClose.emit(event);
  }

  private initialize() {
    this.menuImage.push({
        label: this._translate.instant('Compo_Cut'),
        icon: 'pi pi-share-alt',
        action: 'slice'
    });
    this.menuImage.push({
      label: this._translate.instant('Compo_Rotate'),
      icon: 'pi pi-sync',
      action: 'rotate'
    });
    this.menuImage.push({
      label: this._translate.instant('Compo_Del'),
      icon: 'pi pi-trash',
      action: 'delete'
    });
    this.menuImage.push({
      label: this._translate.instant('Compo_Cancel'),
      icon: 'pi pi-undo',
      action: ''
    });
  }

}
